import { logout } from '../../features/auth/store/auth.slice';

const authErrorMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.payload?.status === 'error' && action.payload?.errors[0]?.code === 401) {
    store.dispatch(logout());
    window.location.href = '/login';
  }

  return result;
};

export default authErrorMiddleware;
